import { useEffect, useState } from 'react';

import spot from 'data/spot.json';

import { SpotData } from 'types/spot';

/**
 * 渡したIDに紐づくエリア情報を取得します。
 * @param id {string} - 探索エリアのid
 * @returns
 * @example
 * import { useParams } from 'react-router-dom';
 * import { useGetArticleData } from 'hooks/useGetArticleData';
 * export const MyComponent: FC = () => {
 *   const { id } = useParams<{ id?: string }>();
 *   const article = useGetArticleData(id || '');
 *
 *   return (
 *     <div>
 *       {article?.name}
 * </div>
 *   );
 * };
 */
export function useGetArticleData(id: string | undefined): SpotData | null {
  const [article, setArticle] = useState<SpotData | null>(null);

  useEffect(() => {
    const spotList: SpotData[] = spot as unknown as SpotData[];
    const foundArticle = spotList.find(item => item.id === id) as unknown as SpotData;

    setArticle(foundArticle);
  }, [id]);

  return article;
}
